var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./QuoteAttribution.css";

var QuoteAttribution = function (_Component) {
  _inherits(QuoteAttribution, _Component);

  function QuoteAttribution() {
    _classCallCheck(this, QuoteAttribution);

    return _possibleConstructorReturn(this, (QuoteAttribution.__proto__ || Object.getPrototypeOf(QuoteAttribution)).apply(this, arguments));
  }

  _createClass(QuoteAttribution, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          block = _props.block,
          extras = _props.extras;

      var isStyledQ = extras.styledQuoteAttributions.includes(block.key);
      return React.createElement(
        "div",
        { className: classNames(styles.root, isStyledQ ? styles.centered : {}) },
        "" + (block.text && "— ") + this.props.children
      );
    }
  }]);

  return QuoteAttribution;
}(Component);

QuoteAttribution.propTypes = {
  block: PropTypes.object.isRequired,
  extras: PropTypes.object.isRequired
};

export default QuoteAttribution;


// WEBPACK FOOTER //
// ./src/components/Library/QuoteAttribution/QuoteAttribution.js